<template>
	<div class="user-assign-select-inline-footer">
		<template v-if="hasActiveRoleFilter">
			<SuiButton
				class="user-assign-select-inline-footer__button"
				@click.stop="$emit('remove-role')"
			>
				{{ $t('user_assign_select_unassign_role') }}
			</SuiButton>
		</template>
		<template v-if="isApplyAndNotifyVisible && !hasActiveRoleFilter">
			<div
				v-if="taskId"
				class="user-assign-select-inline-footer__action-line"
			>
				<SuiCheckbox
					:model-value="shouldNotify"
					@update:model-value="$emit('update:should-notify', $event)"
				>
					{{ $t('notify') }}
				</SuiCheckbox>
				<SuiButton
					variant="primary"
					class="user-assign-select-inline-footer__apply"
					@click="$emit('assign-users')"
				>
					{{ $t('apply') }}
				</SuiButton>
			</div>
		</template>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { SuiButton, SuiCheckbox } from '@developers/scoro-ui';
import type { Task } from '@/generated/graphql';
import type { UserAssignSelectRole } from '../../types';

export interface UserAssignSelectInlineFooterProps {
	taskId?: Task['id'];
	shouldNotify?: boolean;
	activeRoleFilterId: UserAssignSelectRole['id'] | null;
	isApplyAndNotifyVisible?: boolean;
}

const { activeRoleFilterId, isApplyAndNotifyVisible = false } =
	defineProps<UserAssignSelectInlineFooterProps>();

const hasActiveRoleFilter = computed(() => activeRoleFilterId !== null);
defineEmits<{
	'update:should-notify': [value: boolean];
	'assign-users': [];
	'remove-role': [];
}>();
</script>

<style lang="scss" scoped>
.user-assign-select-inline-footer {
	display: flex;
	justify-content: center;
	width: 100%;
	margin-bottom: 1.5rem;

	&__button {
		--sui-button-background-color: #{$red-10};
		--sui-button-hover-background-color: #{$red-20};

		color: #{$red-90};
	}

	&__action-line {
		display: grid;
		width: 100%;
		grid-template-columns: 1fr auto 1fr;
		align-items: center;
	}

	&__apply {
		grid-column: 2;
	}
}
</style>
